<template>
  <div
    id="search"
    data-component-id="SearchBar"
  >
    <v-text-field
      v-model="searchInput"
      outlined
      dense
      hide-details
      clearable
      prepend-inner-icon="mdi-magnify"
      placeholder="Recherche"
      transition="scale-transition"
      class="rounded-lg"
      @keyup="search()"
      @click:clear="clearSearch()"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

import store from '@/store';

export default {
  name: 'SearchBar',
  data () {
    return {
      timerID: null,
      searchInput: null
    };
  },
  computed: { ...mapState(['query']) },
  watch: {
    query: {
      immediate: true,
      handler (value) {
        this.searchInput = value;
      }
    }
  },
  methods: {
    ...mapActions(['setQuery']),
    ...mapMutations(['_setQuery']),
    search () {
      clearTimeout(this.timerID);

      this.timerID = setTimeout(() => {
        store.dispatch('setQuery', this.searchInput);
      }, 500);
    },
    clearSearch () {
      store.dispatch('setQuery', null);
    }
  }
};
</script>

<style lang="scss">
#adv-search {
  position: relative;
}
.search-holder {
  position: relative;
  width: 100%;
  max-width: 600px;
}
.overlay {
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  background-color: #00000080;
}
</style>
